
import React from 'react';
import { Header } from '../../components/feature/Header';
import { Footer } from '../../components/feature/Footer';
import { BannerSection } from './components/BannerSection';
import { AboutContentSection } from './components/AboutContentSection';
import { TeamSection } from './components/TeamSection';
import { MissionSection } from './components/MissionSection';
import { WhyChooseUsSection } from './components/WhyChooseUsSection';

const AboutPage: React.FC = () => {
  return (
    <div className="min-h-screen bg-white">
      <Header />
      <main>
        <BannerSection />
        <AboutContentSection />
        <MissionSection />
        <TeamSection />
        <WhyChooseUsSection />
      </main>
      <Footer />
    </div>
  );
};

export default AboutPage;
